export default __webpack_public_path__ + "media/images/dog-decor-2-80a2608de3114c7f65a0a64675caa460.svg";